export function uniqueBy<T>(arr: T[], selector: (item: T) => any | keyof T) {
    const map = new Map();
    arr.forEach(item => {
        const key = typeof selector === 'function' 
        ? selector(item) 
        : item[selector];
        if (!map.has(key)) map.set(key, item);
    });
    return Array.from(map.values()) as T[];
}